export const getRoutePath = (location) => {
    return `${location?.pathname}${!!location?.hash ? location?.hash : ''}`;
};
